module.exports = __webpack_public_path__ + "img/starter-undrgrnd.d339ed1b.png";